/* eslint-disable */

import React from "react";
import "antd/dist/antd.min.css";
import {Form, InputNumber,} from "antd";
import {observer} from "mobx-react-lite";

const TrendConstraint = observer(({
                                      approxConstraintsFirst,
                                      approxConstraintsLast,
                                      deltaValueConstraint,
                                      sawConstraint1,
                                      sawConstraint2,
                                      sawConstraint3,
                                      constraintId,
                                      settingsType,
                                  }) => {
    return (
        <>
            <Form.Item
                labelAlign="left"
                label={`Коэф. угла наклона апроксимируемой прямой`}
                rules={[
                    {required: true, message: "Введите ограничения для апроксимации"},
                ]}
            >
        <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
            1{" "}
        </span>
                <Form.Item initialValue={approxConstraintsFirst}
                           noStyle
                           name={[
                               `${settingsType}`,
                               `${constraintId}`,
                               `approxConstraintsFirst`,
                           ]}
                           rules={[
                               {required: true, message: "Введите ограничения для апроксимации"},
                           ]}
                >
                    <InputNumber
                        min={-999}
                        max={0}
                        style={{
                            width: "30%",
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
                    2{" "}
        </span>
                <Form.Item initialValue={approxConstraintsLast}
                           noStyle
                           name={[`${settingsType}`, `${constraintId}`, `approxConstraintsLast`]}
                           rules={[
                               {required: true, message: "Введите ограничения для апроксимации"},
                           ]}
                >
                    <InputNumber
                        min={0}
                        max={999}
                        style={{
                            width: "30%",
                        }}
                    />
                </Form.Item>
            </Form.Item>

            <Form.Item
                labelAlign="left"
                label={`Настройка определения изменения показателя`}
                rules={[{required: true, message: "Введите изменение показателя"}]}
            >
        <span className="ant-form-text" style={{paddingLeft: "15px"}}>
          {" "}
            {"   "}
        </span>
                <Form.Item initialValue={deltaValueConstraint}
                           noStyle
                           name={[`${settingsType}`, `${constraintId}`, `deltaValueConstraint`]}
                           rules={[{required: true, message: "Введите изменение показателя"}]}
                >
                    <InputNumber
                        min={0}
                        max={999}
                        style={{
                            width: "30%",
                        }}
                    />
                </Form.Item>
            </Form.Item>

            <Form.Item
                labelAlign="left"
                label={`Настройки для определения поведения «пилы»`}
                rules={[{required: true, message: "Введите коэфициенты «пилы»"}]}
            >
        <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
            1{" "}
        </span>
                <Form.Item initialValue={sawConstraint1}
                           noStyle
                           name={[`${settingsType}`, `${constraintId}`, `sawConstraint1`]}
                           rules={[{required: true, message: "Введите коэфициент «пилы» 1"}]}
                >
                    <InputNumber
                        min={0}
                        max={999}
                        style={{
                            width: "20%",
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
                    2{" "}
        </span>
                <Form.Item initialValue={sawConstraint2}
                           noStyle
                           name={[`${settingsType}`, `${constraintId}`, `sawConstraint2`]}
                           rules={[{required: true, message: "Введите коэфициент «пилы» 2"}]}
                >
                    <InputNumber
                        min={0}
                        max={999}
                        style={{
                            width: "20%",
                        }}
                    />
                </Form.Item>
                <span className="ant-form-text" style={{paddingLeft: "5px"}}>
          {" "}
                    3{" "}
        </span>

                <Form.Item initialValue={sawConstraint3}
                           noStyle
                           name={[`${settingsType}`, `${constraintId}`, `sawConstraint3`]}
                           rules={[{required: true, message: "Введите коэфициент «пилы» 3"}]}
                >
                    <InputNumber
                        min={0}
                        max={999}
                        style={{
                            width: "20%",
                        }}
                    />
                </Form.Item>
            </Form.Item>
        </>
    );
});

export default TrendConstraint;
